import { render, staticRenderFns } from "./PendingView.vue?vue&type=template&id=0493e4c6&"
import script from "./PendingView.vue?vue&type=script&lang=js&"
export * from "./PendingView.vue?vue&type=script&lang=js&"
import style0 from "./PendingView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports